import React from "react"
import { ButtonHLPure } from "../../pures"

const ContractorsCatalogAddiotionalData = (props) => {

    let {
        hideShowDetails
    } = props

    return (
        <>
            <h1>Pantalla de datos adicionales</h1>
            <ButtonHLPure
                nameBtn = {'Regresar'}
                primary = {false}
                onClickBtn = {hideShowDetails}
            />
        </>
    )
}

export default ContractorsCatalogAddiotionalData